import React from 'react';
import Header from './components/header/header';
import About from './components/about/about';
import Resume from './components/resume/resume';
import Footer from './components/footer/footer';
import Services from './components/services/services'

function App() {
  return (
    <div className="App">
      <Header />
      <About />
      <Services />
      <Resume />
      <Footer />
    </div>
  );
}

export default App;
